import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import OurExperience from './pages/OurExperience';
import CompletedProjects from './pages/CompletedProjects';

import './scss/App.scss';
import ScrollToTop from './components/ScrollToTop';
import WhatsappIcon from './components/WhatsappIcon';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/nuestra-experiencia" element={<OurExperience />} />
            <Route path="/trabajos-realizados" element={<CompletedProjects />} />
            <Route path="/" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsappIcon />
      </div>
    </Router>
  );
}

export default App;
